import GoogleChart from "../../../../components/googleChart/googleChart";
import { connect } from "react-redux";

export default connect(state => ({
  chartName: "dashboard_membership_breakdown_chart",
  width: "1350px",
  height: 350,
  chartType: "LineChart",
  rows: state.membershipDetails.chartData.data_table.rows,
  columns: state.membershipDetails.chartData.data_table.cols,
  listeners: state.membershipDetails.chartData.listeners,
  options: state.membershipDetails.chartData.options,
  enableLineChartTooltip: true
}))(GoogleChart);
